import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "22",
  viewBox: "0 0 23 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("rect", {
      x: "0.75",
      y: "0.5",
      width: "21",
      height: "21",
      rx: "10.5",
      fill: _ctx.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("rect", {
      x: "0.75",
      y: "0.5",
      width: "21",
      height: "21",
      rx: "10.5",
      stroke: _ctx.stroke
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M11.8906 8.4375V17H10.5938V8.4375H11.8906ZM11.2578 5.23438C11.4714 5.23438 11.6536 5.30469 11.8047 5.44531C11.9609 5.58073 12.0391 5.79427 12.0391 6.08594C12.0391 6.3724 11.9609 6.58594 11.8047 6.72656C11.6536 6.86719 11.4714 6.9375 11.2578 6.9375C11.0339 6.9375 10.8464 6.86719 10.6953 6.72656C10.5495 6.58594 10.4766 6.3724 10.4766 6.08594C10.4766 5.79427 10.5495 5.58073 10.6953 5.44531C10.8464 5.30469 11.0339 5.23438 11.2578 5.23438Z",
      fill: _ctx.stroke
    }, null, 8, _hoisted_4)
  ]))
}